module.exports = __webpack_public_path__ + "img/receipt38.ac1df713.svg";